export class EntitySoftLabels {
  ClientsLabel: string;
  EstatesLabel: string;
  PropertiesLabel: string;
  HeadLeasesLabel: string;
  LeasesLabel: string;
  UnitsLabel: string;
  VacantsLabel: string;

  ClientParentsLabel: string;
  ManagersLabel: string;
  TenantsLabel: string;
  TenantParentsLabel: string;
  DebtorsLabel: string;
  CreditorsLabel: string;
  LandlordsLabel: string;
  SuppliersLabel: string;
  constructor() {

  }
}
